function* idMaker() {
    let mut_i = 0;
    while (true) {
        yield mut_i;
        mut_i += 1;
    }
}
const observableIdMaker = idMaker();
const subscriberIdMaker = idMaker();
const tokenMaker = idMaker();
export const issueObservableId = () => observableIdMaker.next().value;
export const issueSubscriberId = () => subscriberIdMaker.next().value;
export const issueToken = () => tokenMaker.next().value;
